// Task numbers included in the fleet "Overview" filter.
// These are the major inspection packages shown by default on the calendar and due list.
export const OVERVIEW_TASK_NUMBERS = new Set([
  '05-20-01',          // IFA-200 Hour Special Inspection
  '05-20-02',          // IFA-A Inspection
  '05-20-03',          // IFA-B Inspection
  '05-20-04',          // IFA-C Inspection
  '05-20-05',          // IFA-D Inspection
  'pkg a 200 hour',    // A Inspection
  'pkg b 400 hour',    // B Inspection
  'pkg c 1200 hour',   // C Inspection
  'pkg d 2400 hour',   // D Inspection
  '72-00-00',          // Hot Section Inspection
  '72-00-00 (hsi)',    // Hot Section Inspection (alternate form)
])

export function isOverviewItem(item) {
  const taskNo = (item['taskNo'] || '').toLowerCase().trim()
  return OVERVIEW_TASK_NUMBERS.has(taskNo)
}

// Short label shown on the Gantt chart callout for each overview inspection type.
export function getInspectionLabel(item) {
  const t = (item['taskNo'] || '').toLowerCase().trim()
  if (t === '05-20-02' || t === 'pkg a 200 hour') return 'A'
  if (t === '05-20-03' || t === 'pkg b 400 hour') return 'B'
  if (t === '05-20-04' || t === 'pkg c 1200 hour') return 'C'
  if (t === '05-20-05' || t === 'pkg d 2400 hour') return 'D'
  if (t === '72-00-00' || t === '72-00-00 (hsi)') return 'HSI'
  if (t === '05-20-01') return 'S'
  return null
}

// Full name for the Gantt tooltip — distinguishes IFA vs. pkg-based inspections.
export function getInspectionFullName(item) {
  const t = (item['taskNo'] || '').toLowerCase().trim()
  if (t === '05-20-01') return 'IFA-200 Hour Special Inspection'
  if (t === '05-20-02') return 'IFA-A Inspection'
  if (t === '05-20-03') return 'IFA-B Inspection'
  if (t === '05-20-04') return 'IFA-C Inspection'
  if (t === '05-20-05') return 'IFA-D Inspection'
  if (t === 'pkg a 200 hour') return 'A Inspection'
  if (t === 'pkg b 400 hour') return 'B Inspection'
  if (t === 'pkg c 1200 hour') return 'C Inspection'
  if (t === 'pkg d 2400 hour') return 'D Inspection'
  if (t === '72-00-00' || t === '72-00-00 (hsi)') return 'Hot Section Inspection'
  return null
}
